module.exports = __webpack_public_path__ + "img/Dview_1-1.f8901763.png";